import { createFileRoute, redirect } from "@tanstack/react-router";
import { authSearchSchema } from "@/features/auth/redirect";

export const Route = createFileRoute("/sign-in")({
  validateSearch: authSearchSchema,
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/auth/sign-in", search, replace: true });
  },
});
